import { match } from '@frontend/duck-tape';
import { usePaywallContext } from '@frontend/react-domain';
import { PaymentStep, SelectPurchaseTypeStep, SelectSubscriptionPlanStep, SuccessStep } from './Steps';

export const PaywallFlow = () => {
  const { paywallState } = usePaywallContext();

  const currentStep = paywallState.navigation.currentStep;

  const result = match({
    currentStep,
    firstPurchaseData: paywallState.purchase,
    selectedPurchaseType: paywallState.purchase.selectedPurchaseType,
  })
    .with({ currentStep: 'selectPurchaseType' }, () => <SelectPurchaseTypeStep />)
    .with({ currentStep: 'selectSubscriptionPlan', selectedPurchaseType: 'Subscription' }, () => (
      <SelectSubscriptionPlanStep />
    ))
    .with({ currentStep: 'checkout' }, () => <PaymentStep />)
    .with({ currentStep: 'success' }, () => <SuccessStep />)
    .otherwise(() => null);

  return <div style={{ height: '100%', width: '100%' }}>{result}</div>;
};
